export function concat (items, sep = ' ') {
  return Array.isArray(items) ? items.filter(Boolean).join(sep)
    : [...arguments].join(' ')
}
